var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgStatusIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Status Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.1194 53.6496C10.4451 51.0667 8.31197 47.977 6.84452 44.5609C5.37707 41.1448 4.60465 37.4706 4.57235 33.7528C4.54004 30.035 5.24849 26.348 6.65635 22.9069C8.06422 19.4658 10.1433 16.3395 12.7723 13.7105C15.4013 11.0815 18.5275 9.00245 21.9686 7.59458C25.4097 6.18672 29.0968 5.47827 32.8146 5.51058C36.5324 5.54289 40.2066 6.3153 43.6227 7.78275C47.0388 9.2502 50.1285 11.3833 52.7114 14.0576C57.8118 19.3385 60.634 26.4113 60.5702 33.7528C60.5064 41.0943 57.5617 48.1171 52.3703 53.3085C47.1789 58.4999 40.1561 61.4447 32.8146 61.5085C25.4731 61.5723 18.4002 58.75 13.1194 53.6496ZM30.1154 19.8536V36.6536H35.7154V19.8536H30.1154ZM30.1154 42.2536V47.8536H35.7154V42.2536H30.1154Z",
    fill: "#4697E0"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStatusIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Status_Icon.6eda6a7f.svg";
export { ForwardRef as ReactComponent };